import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SegmentContext } from './Context';
import { SegmentDesktop } from '../SegmentDesktop';
import { FieldType, SearchSegment, TripTypeProp } from '../../../../models';
import { ConnectedFaresProvider } from '../../../../components/Calendar/Context/FaresProvider';
import { displayFaresInCalendar, getSegments, getTripType } from '../../../../redux/currentSearch/selectors';

export class SegmentManagerDefaultDesktop extends PureComponent {
    state = {
        fieldFocused: null,
    };

    componentDidUpdate(prevProps) {
        const { tripType, segments } = this.props;
        const { fieldFocused } = this.state;
        const prevSegments = prevProps.segments;
        if (prevProps.tripType !== tripType) {
            this.setState({ fieldFocused: null });
        } else if (prevSegments !== segments && prevSegments.length === segments.length) {
            const changedSegment = this.getChangedSegment(prevSegments);
            const changedPrevSegment = this.getChangedPrevSegment(prevSegments);
            if ((!fieldFocused || !this.cleanCityFocused(fieldFocused.field, changedSegment)) &&
                !this.swapWasClicked(changedPrevSegment, changedSegment)) {
                this.focusNext(segments);
            }
        }
    }

    getChangedPrevSegment(prevSegments) {
        const { segments } = this.props;
        return prevSegments.find((prevSegment, i) => segments[i] !== prevSegment);
    }

    getChangedSegment(prevSegments) {
        const { segments } = this.props;
        return segments.find((segment, i) => segment !== prevSegments[i]);
    }

    cleanCityFocused = (field, segment) => {
        return field === FieldType.DEPARTURE && !segment.origin || (field === FieldType.ARRIVAL && !segment.destination);
    }

    swapWasClicked = (prevSegment, segment) => {
        return segment && ((!!segment.origin === !!prevSegment.destination) ||
            (prevSegment.destination && prevSegment.destination.geoNodeId === 0)) &&
            segment.destination === prevSegment.origin &&
            segment.date === prevSegment.date;
    }

    focusNext = (nextState) => {
        const nextField = this.nextFieldToBeFocused(nextState);
        if (nextField) {
            this.onChangeFocus(nextField.leg, nextField.field, true);
        }
    }

    nextFieldToBeFocused = (segments) => {
        let nextField = null;
        for (let i = 0; i < segments.length && nextField === null; i++) {
            if (!segments[i].origin) {
                nextField = { leg: i, field: FieldType.DEPARTURE };
            } else if (!segments[i].destination) {
                nextField = { leg: i, field: FieldType.ARRIVAL };
            } else if (!segments[i].date) {
                nextField = { leg: i, field: FieldType.DATE };
            }
        }
        return nextField;
    }

    onChangeFocus = (leg, field, focus) => {
        if (focus) {
            this.setState({
                fieldFocused: {
                    leg,
                    field,
                },
            });
        } else {
            this.setState({ fieldFocused: null });
        }
    }

    render() {
        const { segments, displayFaresInCalendar } = this.props;
        const { fieldFocused } = this.state;
        return (
            <div>
                {segments.map((segment, i) => {
                    const field = (fieldFocused && fieldFocused.leg === i) ? fieldFocused.field : null;
                    return (
                        <SegmentContext.Provider key={segment.id} value={{ segment }}>
                            <ConnectedFaresProvider
                                desktop
                                segmentId={segment.id}
                                displayFaresInCalendar={displayFaresInCalendar}
                            >
                                <SegmentDesktop
                                    key={segment.id}
                                    index={i}
                                    fieldFocused={field}
                                    onChangeFocus={this.onChangeFocus}
                                />
                            </ConnectedFaresProvider>
                        </SegmentContext.Provider>
                    );
                }, this)}
            </div>
        );
    }
}

SegmentManagerDefaultDesktop.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    tripType: TripTypeProp.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
};

SegmentManagerDefaultDesktop.defaultProps = {
    segments: [],
};

const mapStateToProps = createStructuredSelector({
    segments: getSegments,
    tripType: getTripType,
    displayFaresInCalendar: displayFaresInCalendar,
});

const ConnectedSegmentManagerDefaultDesktop = connect(mapStateToProps)(SegmentManagerDefaultDesktop);

export { ConnectedSegmentManagerDefaultDesktop };
